import { Injectable } from '@angular/core';

@Injectable()
export class StringHelper{

    _prettifyNumSecuriteSociale(num){
        const nns = num.replace(/\D/g,'');
        const l = nns.length;

        return nns.substr(0,1)+" "+nns.substr(1,2)+" "+nns.substr(3,2)+" "+nns.substr(5,2)+" "+nns.substr(7,3)+" "+nns.substr(10,3);
 
    }

    prettifyNumSecuriteSociale(num){
        const nns = num.replace(/\D/g,'');
        const l = nns.length;
         
        if(l === 2){
          return nns.substr(0,1)+" "+nns.substr(1,1);
        }
        if(l === 4){
          return nns.substr(0,1)+" "+nns.substr(1,2)+" "+nns.substr(3,1);
        }
        if(l === 6){
          return nns.substr(0,1)+" "+nns.substr(1,2)+" "+nns.substr(3,2)+" "+nns.substr(5,1);
        }
        if(l === 8){
          return nns.substr(0,1)+" "+nns.substr(1,2)+" "+nns.substr(3,2)+" "+nns.substr(5,2)+" "+nns.substr(7,1);
        }
        if(l === 11){
          return nns.substr(0,1)+" "+nns.substr(1,2)+" "+nns.substr(3,2)+" "+nns.substr(5,2)+" "+nns.substr(7,3)+" "+nns.substr(10,1);
        }
        if(l === 13){
          return "focus";
        }
        return false;
    }

}